import { IUser } from './../../../models/IUser';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IOrg } from 'app/models/IOrg';
import { AdminService } from 'app/services/admin.service';

@Component({
  selector: 'app-create-org',
  templateUrl: './create-org.component.html',
  styleUrls: ['./create-org.component.scss']
})
export class CreateOrgComponent implements OnInit {

  public data: IOrg[];
  public isRequesting: boolean;
  public form: FormGroup;
  public user: IUser;
  public model: IOrg = { id: '', name: '', email: '', owner: this.user };
  constructor(private formBuilder: FormBuilder,
    private adminService: AdminService) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      name: [null, Validators.required]
    });
  }

  setOrg(item: IOrg) {
    this.model = item;
    // alert("Hello, Gianna!");
  }

  createOrg() {
    this.isRequesting = true;
    if (this.form.valid) {
      this.adminService.createOrg(this.model).subscribe(
        result => {
          this.data.push(result);
          this.isRequesting = false;
        })

    }
  }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/org/create-org/create-org.component.ts